import UserAPI from '@/api/user';
import Cookies from 'js-cookie';
import * as types from '@/store/mutation-types';

// state
export const state = {
    user: Cookies.get('user') ? JSON.parse(Cookies.get('user')) : null,
    csrf: Cookies.get('XSRF-TOKEN')
};

// getters
export const getters = {
    user: state => state.user,
    check: state => state.user !== null,
    csrf: state => state.csrf
};

// mutations
export const mutations = {
    [types.FETCH_USER_SUCCESS](state, {user}) {
        state.user = user;
        Cookies.set('user', JSON.stringify(user));
    },

    [types.LOGOUT](state) {
        state.user = null;
        Cookies.remove('user');
    },

    [types.UPDATE_USER](state, {user}) {
        state.user = user;
        Cookies.set('user', JSON.stringify(user));
    }
};

// actions
export const actions = {

    async login({commit},{username,password}) {
        const {data} = await UserAPI.doLogin(username,password);

        commit(types.FETCH_USER_SUCCESS, {user: data});
    },

    async fetchUser({commit}) {
        const {data} = await UserAPI.getCurrentUser();

        commit(types.FETCH_USER_SUCCESS, {user: data.results});
    },

    updateUser({commit}, payload) {
        commit(types.UPDATE_USER, payload);
    },

    async logout({commit}) {
        await UserAPI.doLogout();

        commit(types.LOGOUT);
    },

    clearUserData({commit}) {
        commit(types.LOGOUT);
    }
};
